import Map from '../../../common/components/map'
import React from 'react'
import _ from 'lodash';

export default function AgentMapTrackerComponent({ Shippinglocation, agentTrack }: any) {
    const image = require('../../../assets/img/delivery.png')
    const originGps = Shippinglocation?.fulfillments[0]?.start?.location?.gps;
    const destinationGps = Shippinglocation?.fulfillments[0]?.end?.location?.gps;
    const latLongData: any = _.split(originGps, ',');
    return (
        <>

            <div className="w-full bg-white p-2 text-gray-800">

                <div className="w-full">
                    <Map
                        lat={agentTrack[0]?.Latitude || latLongData[0]}
                        lng={agentTrack[0]?.Longitude || latLongData[1]}
                        height={'300px'}
                        zoom={15}
                        icon={image}
                        showInfoWindow={false}
                        isRouteDirection={true}
                        originLocation={originGps}
                        destinationLocation={destinationGps}
                    />

                </div>
            </div>

        </>
    )
}